/* src/app/components/short-info-modal/short-info-modal.component.scss */
* {
  color: white;
}
p {
  line-height: 22px;
}
h1 {
  margin: 0;
  padding: 0 4px;
}
ion-icon {
  width: 48px;
  height: 48px;
}
ion-row {
  padding: 8px;
  background: var(--ion-color-primary);
  text-align: center;
}
ion-row ion-col {
  padding: 12px;
}
.add-to-order-button {
  color: var(--ion-color-primary);
  background: white;
}
/*# sourceMappingURL=short-info-modal.component.css.map */
